import { Component, OnInit } from '@angular/core';
import { FilterOption } from 'src/app/models/filter-option';
import { BehaviorSubject } from 'rxjs';
import { BlogService } from 'src/app/services/blog.service';
import { BlogPost } from 'src/app/models/blogpost';
import { Router } from '@angular/router';

@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.scss']
})
export class ArticlesComponent implements OnInit {
  private perPage=20;
  public loadingPosts: boolean = true;
  public paginatedPosts = new BehaviorSubject<any>(null);
  public availableFilters=[];
  private filterString='filter[published]';

  constructor(
    private _posts: BlogService,
    private _router: Router
  ) {
    this.availableFilters.push(new FilterOption({name:'title',type:'string'}));
    this.availableFilters.push(new FilterOption({
      name:'published',
      type:'select',
      'options':[
        {name:'Any',value:''},
        {name:'Yes',value:1},
        {name:'No', value:0}
      ],
      default: ''
    }));
  }

  ngOnInit() {
    this.getPosts(1);
  }

  public getPosts(page:number){
    this._posts.getAll(page, this.perPage, this.filterString).subscribe(
      res=>{
        this.paginatedPosts.next(res);
        this.loadingPosts=false;
      }
    );
  }

  public addNewPost(){
    let newPost = new BlogPost({});
    newPost.title='New Blog Post Title';
    newPost.body='New Blog Post Body';
    newPost.published=false;
    newPost.points=0;
    newPost.tile_image='default.jpg';
    this._posts.createPost(newPost).subscribe(
      res=>{
        this._router.navigate(['/articles/'+res.id]);
      }
    );
  }

  pageChanged(data){
    this.perPage=data.pageSize;
    this.getPosts(data.pageIndex+1);
  }

  perPageChanged(data){
    this.perPage=data.pageSize;
    this.getPosts(1);
  }

  filterChanged(filters){
    this.filterString = filters;
    this.getPosts(1);
  }
}
